<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'daniel'
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  body{
    background-color: #F6F6F6;
    padding: 0;
    margin: 0;
    overflow-x:hidden;
		background-image: url('~@/assets/pattern_topography.png');
  }
</style>



// WEBPACK FOOTER //
// src/App.vue